import { useState } from 'react';
import type { ReactNode } from 'react';
import styles from './ConfirmDeletePoll.module.css';
import { Dialog, dialogStyles } from './Dialog';
import ui from './ui.module.css';

/**
 * The one irreversible action in the product. The administrator types the
 * poll's exact title, and the **API** checks it too (`confirm_mismatch`) — this
 * dialog is a courtesy, not the rule (02-requirements.md §Poll Administration).
 *
 * The consequences are spelled out because they are not recoverable and are not
 * obvious: the votes, the ledger and the hourly standing go with the poll.
 */
export function ConfirmDeletePoll({
  title,
  pending,
  error,
  onConfirm,
  onClose,
}: {
  title: string;
  pending: boolean;
  error: string | null;
  onConfirm: (typed: string) => void;
  onClose: () => void;
}): ReactNode {
  const [typed, setTyped] = useState('');

  return (
    <Dialog title="Apagar enquete" onClose={onClose}>
      <p className={ui.muted}>
        Isto apaga a enquete <strong>{title}</strong>, todas as suas opções, todos os votos já dados e todo o
        histórico de liderança. Não há como desfazer. Digite o título exato para confirmar.
      </p>
      <input
        className={`${ui.input} ${styles.input}`}
        aria-label="Título exato da enquete"
        value={typed}
        onChange={(event) => setTyped(event.target.value)}
        placeholder={title}
      />
      {error ? <p className={ui.error}>{error}</p> : null}
      <div className={dialogStyles.actions}>
        <button type="button" className={ui.ghost} onClick={onClose}>
          Cancelar
        </button>
        <button
          type="button"
          className={ui.danger}
          disabled={pending || typed.trim() !== title}
          onClick={() => onConfirm(typed.trim())}
        >
          {pending ? 'Apagando…' : 'Apagar para sempre'}
        </button>
      </div>
    </Dialog>
  );
}
